/**
 * 为矩阵表格计算「产品系列」列的 rowspan 合并信息。
 * 相邻且系列相同的行合并为一个单元格。
 */
export function buildSeriesRowGroups(products, getSeriesKey) {
  return (products || []).map((item, index) => {
    const seriesKey = getSeriesKey(item);
    const isFirst = index === 0 || getSeriesKey(products[index - 1]) !== seriesKey;
    let rowspan = 1;
    if (isFirst) {
      for (let j = index + 1; j < products.length; j++) {
        if (getSeriesKey(products[j]) === seriesKey) rowspan++;
        else break;
      }
    }
    return { item, showSeries: isFirst, seriesRowspan: isFirst ? rowspan : 0 };
  });
}
